import { useMutation } from "@tanstack/react-query";

import { Booking } from "../../../../models/booking";
import { CartonView } from "../../../../models/carton";
import { PurchaseOrder } from "../../../../models/purchase.order";
import { GenerateSSCC } from "../../../../models/sscc";
import CartonReportService from "../../../../services/carton.report.service";
import SSCCService from "../../../../services/sscc.service";
import { CartonKeys } from "../../../../util/queries";
import { saveLabelReport } from "../util";

interface CartonReportPayload {
  cartons: CartonView[];
  booking?: Booking;
  purchaseOrder?: PurchaseOrder;
  bookingCartonsTotal?: number;
}

interface GenerateSSCCWithCartonData {
  sscc: GenerateSSCC;
  cartonsData: CartonView[];
}

const useAction = () => {
  const useGenerateCartonReport = () => {
    return useMutation({
      mutationKey: CartonKeys.generateReport(),
      mutationFn: ({ cartons, booking, purchaseOrder, bookingCartonsTotal }: CartonReportPayload) =>
        CartonReportService.generate(cartons, booking, purchaseOrder, bookingCartonsTotal),
      onSuccess: (response) => {
        if (response && response.data) saveLabelReport(response.data);
      },
    });
  };

  const useGenerateSSCC = () => {
    return useMutation({
      mutationKey: CartonKeys.generateSSCC(),
      mutationFn: (sscc: GenerateSSCC) => SSCCService.generate(sscc),
    });
  };

  const useGenerateMultipleSSCC = () => {
    return useMutation({
      mutationKey: CartonKeys.generateMultipleSSCC(),
      mutationFn: (ssccWithCartons: GenerateSSCCWithCartonData) =>
        SSCCService.generate(ssccWithCartons.sscc),
    });
  };

  return {
    useGenerateCartonReport,
    useGenerateSSCC,
    useGenerateMultipleSSCC,
  };
};

export default useAction;
